var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-header--logo"},[_c('tg-logo',{attrs:{"site":_vm.site},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }